import styles from "../../styles/pages/home-dashboard.module.scss";
import Box from "@mui/material/Box";
import { Button, Grid, Menu, MenuItem } from "@mui/material";
import React, { memo, useEffect, useMemo, useRef } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { Link } from "react-router-dom";
import assest from "../../json/assest/index";
import { useInfiniteQuery } from "react-query";
import { customTopAcquisitorsList } from "../../api/functions/user.api";
import InfiniteScroll from "react-infinite-scroll-component";
import { useInView } from "react-intersection-observer";

const TopAcquisitors = ({
  // ref,
  handleToggleTopApproved = () => {},
  openTopApproved = false,
  showMore1,
  filteredDate,
}) => {
  const [buttonText, setButtonText] = React.useState("Approved");
  const scrollRef = useRef(null);
  const [showEndOfList, setShowEndOfList] = React.useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);
  const showListHandler = () => setIsDropdownOpen(!isDropdownOpen);
  // console.warn("showEndOfList", showEndOfList);

  const handleMenuItemClick = () => {
    if (buttonText === "Approved") {
      // handleToggleTopApproved(true);
      setButtonText("All submissions");
      showListHandler();
    } else {
      // handleToggleTopApproved(false);
      setButtonText("Approved");
      showListHandler();
    }
  };

  const { data, fetchNextPage, hasNextPage, refetch } = useInfiniteQuery({
    queryKey: ["customTopAcquisitorsList", filteredDate],
    queryFn: ({ pageParam = 1 }) => {
      // console.warn(pageParam, "pageParam");
      return customTopAcquisitorsList(filteredDate, pageParam);
    },
    keepPreviousData: true,

    enabled: !!filteredDate,

    getNextPageParam: (lastPage, allPages) => {
      if (
        allPages[allPages.length - 1 || 0]?.current_page <
        allPages[0]?.last_page
      ) {
        return allPages[allPages.length - 1 || 0]?.current_page + 1;
      } else {
        return undefined;
      }
    },
  });
  // console.warn("data", data);
  const topAcquisitor = useMemo(() => {
    var dat = { data: [] };
    data?.pages?.forEach((item) => {
      dat = { ...item, data: [...dat?.data, ...item.data] };
    });
    return dat;
  }, [data]);

  useEffect(() => {
    function handleClickOutside(event) {
      // console.warn("Clicked outside");
      if (isDropdownOpen && !event.target.closest(`.${styles.year_drop}`)) {
        setIsDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  const { ref, inView } = useInView({
    threshold: 0,
  });

  // console.warn("topAcquisitor", topAcquisitor);
  return (
    <>
      <Grid item xs={3.62}>
        <Box
          className={`${styles.commonSmallBoxWrapper} ${styles.commonSmallBoxWrapper2}`}
        >
          <Box className="commonSmallBox commonBoxExpenses">
            <Box
              className={`${styles.commonSmallBox} ${styles.commonSmallBox2}`}
            >
              <Box
                className={`${styles.infoTable} ${styles.infoTableInvitation}`}
              >
                <Box
                  className={`${styles.infoTable_head} ${styles.infoTable_headSecond}`}
                >
                  <Link href="" className={styles.topAcquisitorsHead}>
                    <Box className={styles.tble_hdng}>TOP Acquisitors</Box>
                    <Box className={styles.tble_hdng}>
                      <Button
                        ref={ref}
                        onClick={showListHandler}
                        className={`${
                          isDropdownOpen ? styles.active_drop : null
                        }`}
                      >
                        {buttonText}
                        {isDropdownOpen ? (
                          <img
                            src={assest.upArrow}
                            width={7}
                            height={10}
                            alt=""
                          />
                        ) : (
                          <img
                            src={assest.downArrow}
                            width={7}
                            height={10}
                            alt=""
                          />
                        )}
                      </Button>
                      {isDropdownOpen && (
                        <Box className={styles.year_drop}>
                          <ul onClick={handleMenuItemClick}>
                            <li>
                              {buttonText === "Approved"
                                ? "All submissions"
                                : "Approved"}
                            </li>
                          </ul>
                        </Box>
                      )}
                    </Box>
                  </Link>
                </Box>

                <Box
                  className={`${styles.infoTble_body1}  ${styles.infoTble_body2}`}
                >
                  <Box className={styles.topAcquisitorsBody}>
                    <InfiniteScroll
                      dataLength={topAcquisitor?.data?.length}
                      next={fetchNextPage}
                      height={`calc(100vh - 375px)`}
                      hasMore={hasNextPage}
                      loader={<h4>Loading... </h4>}
                      className={styles.infiniteScrollTop}
                    >
                      {topAcquisitor?.data?.map((item, index) => (
                        <Box
                          className={styles.infoTble_row}
                          // key={item.title}
                        >
                          <Link href="">
                            <Box className={styles.infoTble_cell}>
                              <Box className={styles.acquisitorList}>
                                <Box className={styles.acquisitorListNumber}>
                                  {index + 1}.
                                </Box>
                                <Box className={styles.acquisitorListTxt}>
                                  <h5>{item?.name}</h5>
                                  <p>{item?.role?.display_name}</p>
                                </Box>
                              </Box>
                            </Box>
                            <Box
                              className={`${styles.infoTble_cell} ${styles.app_no}`}
                            >
                              {buttonText === "Approved"
                                ? item?.videos_approved_count
                                : item?.videos_count}
                            </Box>
                          </Link>
                        </Box>
                      ))}
                      <div ref={ref} className="inview-block"></div>
                    </InfiniteScroll>
                  </Box>

                  <Box className={styles.list_btn_area}>
                    {!hasNextPage && inView && (
                      <Button
                        className={styles.end_list_btn}
                        // onClick={() => setShowMore1(!showMore1)}
                      >
                        {/* {showMore1 ? "Show less" : "End of list."} */}
                        End of list.
                      </Button>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Grid>
    </>
  );
};

export default memo(TopAcquisitors);
